import {AxiosError} from 'axios';
import {useMutation} from 'react-query';
import {toast} from 'react-toastify';
import PatchFarmRequirement from '.';

interface IPostFarmRequirementProps {
  onSuccess?: (data: any) => void;
  guid?: string;
}

const usePatchFarmRequirement = ({
  onSuccess,
  guid,
}: IPostFarmRequirementProps) => {
  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (payload: IFarmRequirementPayload) => {
      return PatchFarmRequirement(payload, guid);
    },
    onSuccess: data => {
      onSuccess && onSuccess(data);
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoading, mutate, isSuccess};
};

export {usePatchFarmRequirement};
